export default __webpack_public_path__ + "static/media/mi.2cb37a83.mp3";